import React from 'react';
import { Star } from 'lucide-react';

export function StarRating({ value = 0, onChange, size = 30, testIdPrefix = 'rating' }) {
  return (
    <div className="flex gap-2 items-center select-none" data-testid={`${testIdPrefix}-stars`}>
      {[1, 2, 3, 4, 5].map((n) => (
        <button
          key={n}
          type="button"
          data-testid={`${testIdPrefix}-star-${n}`}
          onClick={() => onChange(n === value ? 0 : n)}
          className="transition-transform active:scale-90 hover:scale-110"
          aria-label={`${n} star`}
        >
          <Star
            size={size}
            className={n <= value ? 'text-[#D4AF37]' : 'text-slate-600'}
            fill={n <= value ? '#D4AF37' : 'none'}
            strokeWidth={1.6}
          />
        </button>
      ))}
    </div>
  );
}
